// extracted by mini-css-extract-plugin
module.exports = {"root":"PackageHeader_root__1o3AC","title":"PackageHeader_title__vM6lv","withLogo":"PackageHeader_withLogo__L3IpX"};